<template>
  <div class="notFound">
    <router-link :to="{name:'home'}">
      <el-button type="primary">点击刷新到首页</el-button>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'notFound'
  }

</script>
<style lang="scss">
  html,
  body {
    margin: 0;
    padding: 0;

    .notFound {
      background: url("../assets/timg.jpg") no-repeat center;
      background-size: 100% 100%;
      width: 100%;
      height: 100%;
      position: relative;

      .el-button {
        position: absolute;
        bottom: 25%;
        left: 45%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/notFound.vue